import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/start',
      name: 'Start',
      component: () => import('@/views/login/start'),
      meta: {
        layout: 'blank',
        index: 1
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/login'),
      meta: {
        layout: 'blank',
        index: 2
      }
    },
    {
      path: '/forget',
      name: 'Forget',
      component: () => import('@/views/login/forget'),
      meta: {
        layout: 'blank',
        index: 3
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/views/login/register'),
      meta: {
        layout: 'blank',
        index: 3
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/views/home'),
      meta: {
        layout: 'member',
        index: 1
      }
    },
    {
      path: '/team',
      name: 'team',
      component: () => import('@/views/team/'),
      meta: {
        layout: 'topbar',
        index: 2
      }
    },
    {
      path: '/team/list/:level/:oneLevelCount/:income',
      name: 'teamList',
      component: () => import('@/views/team/list'),
      meta: {
        layout: 'topbar',
        index: 3
      }
    },
    {
      path: '/invite',
      name: 'invite',
      component: () => import('@/views/invite/'),
      meta: {
        layout: 'topbar',
        index: 2
      }
    },
    // {
    //   path: '/reward',
    //   name: 'reward',
    //   component: () => import('@/views/invite/reward'),
    //   meta: {
    //     layout: 'topbar',
    //     index: 3
    //   }
    // },
    {
      path: '/trade',
      name: 'Trade',
      component: () => import('@/views/trade'),
      meta: {
        layout: 'member',
        index: 1
      }
    },
    {
      path: '/invest/list',
      name: 'Markets',
      component: () => import('@/views/invest'),
      meta: {
        layout: 'member',
        index: 1
      }
    },
    {
      path: '/invest/detail/:id',
      name: 'InvestDetail',
      component: () => import('@/views/invest/detail'),
      meta: {
        layout: 'topbar',
        index: 3
      }
    },
    {
      path: '/invest/records/:id',
      name: 'InvestRecords',
      component: () => import('@/views/invest/records'),
      meta: {
        layout: 'topbar',
        index: 2
      }
    },
    {
      path: '/user/profile',
      name: 'profile',
      component: () => import('@/views/user/profile'),
      meta: {
        layout: 'topbar',
        index: 3
      }
    },
    {
      path: '/user/profile/avatar',
      name: 'avatar',
      component: () => import('@/views/user/profile/avatar'),
      meta: {
        layout: 'topbar',
        index: 4
      }
    },
    {
      path: '/user/profile/nickname',
      name: 'nickname',
      component: () => import('@/views/user/profile/nickname'),
      meta: {
        layout: 'topbar',
        index: 4
      }
    },
    {
      path: '/user/records',
      name: 'Records',
      component: () => import('@/views/records'),
      meta: {
        layout: 'topbar',
        index: 1
      }
    },
    {
      path: '/user/setting',
      name: 'setting',
      component: () => import('@/views/user/setting'),
      meta: {
        layout: 'topbar',
        index: 3
      }
    },
    {
      path: '/user/setting/resetLoginPassword',
      name: 'ResetLoginPassword',
      component: () => import('@/views/user/resetloginpassword'),
      meta: {
        layout: 'topbar',
        index: 4
      }
    },
    {
      path: '/user/setting/resetPaymentPassword',
      component: () => import('@/views/user/resetpaymentpassword'),
      meta: {
        layout: 'topbar',
        index: 4
      }
    },
    {
      path: '/user/help',
      component: () => import('@/views/user/help'),
      meta: {
        layout: 'topbar',
        index: 4
      }
    },
    {
      path: '/message',
      component: () => import('@/views/articles/message'),
      meta: {
        layout: 'topbar',
        index: 2
      }
    },
    {
      path: '/message/detail/:id',
      name: 'messageDetail',
      component: () => import('@/views/articles/messageDetail'),
      meta: {
        layout: 'topbar',
        index: 5
      }
    },
    // {
    //   path: '/transaction',
    //   name: 'Transaction',
    //   component: () => import('@/views/transaction'),
    //   meta: {
    //     layout: 'topbar',
    //     index: 1
    //   }
    // },
    {
      path: '/user',
      name: 'User',
      component: () => import('@/views/user'),
      meta: {
        layout: 'member',
        index: 1
      }
    },
    {
      path: '/user/proposal',
      name: 'proposal',
      component: () => import('@/views/user/proposal'),
      meta: {
        layout: 'topbar',
        index: 3
      }
    },
    {
      path: '/articles/detail/:id',
      name: 'ArticlesDetail',
      component: () => import('@/views/articles/detail'),
      meta: {
        layout: 'topbar',
        index: 5
      }
    },
    {
      path: '/wallet',
      component: () => import('@/views/wallet'),
      meta: {
        layout: 'topbar',
        index: 2
      }
    },
    {
      path: '/paysubmit',
      component: () => import('@/views/wallet/paysubmit'),
      meta: {
        layout: 'topbar'
      }
    },
    {
      path: '/wallet/recharge',
      component: () => import('@/views/wallet/recharge'),
      meta: {
        layout: 'topbar',
        index: 3
      }
    },
    {
      path: '/wallet/withdraw',
      component: () => import('@/views/wallet/withdraw'),
      meta: {
        layout: 'topbar',
        index: 3
      }
    },
    {
      path: '/wallet/addBankCard',
      component: () => import('@/views/wallet/addBankCard'),
      meta: {
        layout: 'topbar',
        index: 3
      }
    },
    {
      path: '/wallet/addUSDTWallet',
      component: () => import('@/views/wallet/addUSDTWallet'),
      meta: {
        layout: 'topbar',
        index: 3
      }
    },
    {
      path: '/wallet/withdrawRecords',
      component: () => import('@/views/wallet/withdrawRecords'),
      meta: {
        layout: 'topbar',
        index: 3
      }
    },
    // {
    //   path: '/flow',
    //   component: () => import('@/views/flow'),
    //   meta: {
    //     layout: 'topbar',
    //     index: 3
    //   }
    // },
    {
      path: '*', // 此处需特别注意置于最底部
      redirect: '/home'
    }
  ],
  linkActiveClass: 'active'
})



// WEBPACK FOOTER //
// ./src/router/index.js